export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center px-4 md:px-6 pt-16">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20product%20photography%20flat%20lay%20with%20pastel%20colored%20fashion%20items%20including%20sneakers%20hoodies%20accessories%20and%20bags%20arranged%20on%20a%20clean%20cream%20white%20background%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20gentle%20shadows%2C%20aesthetic%20composition%2C%20high%20end%20catalog%20look&width=1600&height=900&seq=hero-bg-2026-x1&orientation=landscape"
          alt="GTBuy fashion product photography background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center flex flex-col items-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-900 text-xs font-medium mb-6">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
          Updated Weekly · Free Access
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
          GTBuy Spreadsheet
          <br />
          <span className="text-background-50/80 font-normal italic">Hub for Every Hustler</span>
        </h1>

        <p className="text-background-50/70 text-base md:text-lg max-w-2xl mb-10 leading-relaxed">
          Compare and explore the most updated shopping spreadsheets for 2026.
          Navigate through 14+ curated GTBuy sheet categories, discover verified product lists,
          and shop smarter with trusted sourcing data.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50 text-foreground-950 font-semibold text-sm rounded-lg hover:bg-background-100 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-table-line text-lg"></i>
            GTBuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-background-50/40 text-background-50 font-semibold text-sm rounded-lg hover:bg-background-50/10 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-cart-line text-lg"></i>
            Buy It Now
          </a>
        </div>

        <div className="flex items-center gap-8 mt-12 text-background-50/60 text-xs">
          <div className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Verified Sources
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Beginner Friendly
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            14+ Categories
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}